"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Design___StyledSvg",
  componentId: "sc-18oqwpx-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function Design(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    d: "M14.966 6.166L8.73 12.4l1.835 1.834-1.131 1.131L8.4 14.331l-3.434 3.434a.8.8 0 01-1.131 0l-1.6-1.6a.8.8 0 010-1.13L5.669 11.6l-1.034-1.034 1.13-1.132L7.6 11.27l6.235-6.235L13.2 4.4 16.4 2 18 3.6l-2.4 3.2-.634-.634z",
    fill: "currentColor"
  }), _react["default"].createElement("path", {
    d: "M5.2 8.4c.592 0 1.14-.172 1.616-.453l1.487 1.487 1.131-1.13-1.487-1.488C8.228 6.34 8.4 5.792 8.4 5.2A3.2 3.2 0 005.2 2c-.592 0-1.14.172-1.617.453l2.183 2.181-1.132 1.132-2.181-2.183A3.17 3.17 0 002 5.2c0 1.766 1.433 3.2 3.2 3.2zM14.8 11.6c-.592 0-1.14.172-1.617.453l-1.486-1.488-1.131 1.132 1.487 1.486A3.17 3.17 0 0011.6 14.8c0 1.765 1.433 3.2 3.2 3.2.592 0 1.14-.172 1.616-.453l-2.182-2.182 1.132-1.13 2.181 2.18c.28-.475.453-1.023.453-1.615a3.2 3.2 0 00-3.2-3.2z",
    fill: "currentColor"
  }));
}

var _default = Design;
exports["default"] = _default;